import _ from 'lodash';
import * as type from './types';
export default (state = [], action) => {
  switch (action.type) {
    case type.FETCH_LOCATIONS:
      return { ..._.mapKeys(action.payload, 'id') };
    case type.FETCH_LOCATION:
      return { ...state, [action.payload.id]: action.payload };
    case type.CREATE_LOCATION:
      return { ...state, [action.payload.id]: action.payload };
    case type.EDIT_LOCATION:
      return { ...state, [action.payload.id]: action.payload };
    case type.DELETE_LOCATION:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
